var React = require('react');

function Bed (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 11H12V3.75C10.6667 3.25 9.33333 3 8 3C7.04752 3 6.09505 3.12758 5.14271 3.3826C4.42848 3.12753 3.71424 3 3 3C2.667 3 2.334 3.02772 2.001 3.08317L2 1H0V11H2V9H10V11ZM2.22739 5.07427C2.48778 5.02446 2.74499 5 3 5L3.25578 5.00819C3.42684 5.01912 3.59902 5.04106 3.77261 5.07427L4 5.124V7H2V5.124L2.22739 5.07427Z","fill":"#424242"}));
}

Bed.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Bed;

Bed.default = Bed;
